import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
import presetsReducer from "../features/presets/presetsSlice";
import shippingRulesReducer from "../features/shippingRules/shippingRulesSlice";
import productAnalyzerReducer from "../features/productAnalyzer/productAnalyzer.slice";
import feeSettingsReducer from "../features/feeSettings/feeSettingsSlice";
import userReducer from "../features/user/user.slice";
import settingsReducer from "../features/settings/settings.slice";
import dashboardReducer from "../features/dashboard/dashboard.slice";
import bulkAnalyzerFilesReducer from "../features/bulkAnalyzerFiles/bulkAnalyzerFiles.slice";
import lookupsReducer from "../features/lookups/lookups.slice";
import searchReducer from "../features/search/search.slice";
import billingHistoryReducer from "../features/billingHistory/billingHistory.slice";
import onboardingReducer from "../features/onboarding/onboarding.slice";
import extensionReducer from "../features/extension/extension.slice";
import paymentMethodsReducer from "../features/paymentMethods/paymentMethods.slice";
import pricingPlansReducer from "../features/pricingPlans/pricingPlans.slice";
import sellersReducer from "../features/sellers/sellers.slice";
import subscriptionCouponsReducer from "../features/subscriptionCoupons/subscriptionCoupons.slice";

// Combine your reducers
const rootReducer = combineReducers({
  productAnalyzer: productAnalyzerReducer,
  feeSettings: feeSettingsReducer,
  presets: presetsReducer,
  settings: settingsReducer,
  shippingRules: shippingRulesReducer,
  user: userReducer,
  dashboard: dashboardReducer,
  bulkAnalyzerFiles: bulkAnalyzerFilesReducer,
  lookups: lookupsReducer,
  search: searchReducer,
  billingHistory: billingHistoryReducer,
  onboarding: onboardingReducer,
  extension: extensionReducer,
  paymentMethods: paymentMethodsReducer,
  pricingPlans: pricingPlansReducer,
  sellers: sellersReducer,
  subscriptionCoupons: subscriptionCouponsReducer,
});

// Persist config (persist only dashboard slice, add more to whitelist as needed)
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["settings", "pricingPlans"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  // You may want to customize middleware for redux-persist
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
